
export const dashOrderTags = () => {
    return [
        {key: 'OrderID', value: 'OrderID'},
        {key: 'QuoteID', value: 'QuoteID'},
        {key: 'Status', value: 'Status'},
        {key: 'invoice_date', value: 'Date'},
        {key: 'invoice_total_ex_vat', value: 'Amount'},
        {key: 'original_contact_on_our_side', value: 'Agent'},
        {key: 'PostCode', value: 'Postcode'},
        {key: 'our_trading_name', value: 'Brand'},
    ]
}

export const dashQuoteTags = () => {
    return [
        {key: 'QuoteID', value: 'QuoteID'},
        {key: 'invoice_date', value: 'Date'},
        {key: 'StartDate', value: 'StartDate'},
        {key: 'last_contact_timestamp', value: 'LastContact'},
        {key: 'QuoteStatus', value: 'QuoteStatus'},
        {key: 'invoice_total_ex_vat', value: 'Amount'},
        {key: 'original_contact_on_our_side', value: 'Agent'},
        {key: 'PostCode', value: 'Postcode'},
    ]
}
export const dashCreditTags = () => {
    return [
        {key: 'credit_note_id', value: 'CreditID'},
        {key: 'credit_date', value: 'Date'},
        {key: 'original_contact_on_their_side', value: 'Customer'},
        {key: 'our_trading_name', value: 'Brand'},
        {key: 'credit_issued_against', value: 'IssuedAgainst'},
        {key: 'credit_issued_by', value: 'IssuedBy'},
        {key: 'credit_total_ex_vat', value: 'Amount'},
    ]
}
export const dashJobsTags = () => {
    return [
        {key: 'CarriageID', value: 'CarriageID'},
        {key: 'USCarriageDate', value: 'Date'},
        {key: 'Brand', value: 'Brand'},
        {key: 'depot_name', value: 'Depot'},
    ]
}
export const dashAddressesTags = () => {
    return [
        {key: 'address_id', value: 'AddressID'},
        {key: 'Address1', value: 'Address1'},
        {key: 'Address2', value: 'Address2'},
        {key: 'Town', value: 'Town'},
        {key: 'County', value: 'County'},
        {key: 'PostCode', value: 'Postcode'},
    ]
}